import * as React from 'react'
import { useEffect, useState } from "react"
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { query, queryfigs, groupname } from './confs';

const useStyles = makeStyles({
  textCenter: {
    marginTop: (window.innerHeight - 80)/8,
  },
  table:{
    "marginLeft": "30px",
    width: 150,
    display:"flex",
    "overflow-y": "scroll",
    height: window.innerHeight - 50,
    borderRight: "1px solid darkgrey"
  },
  lefttableimg: {
    width: 100,
  },
  lefttableimgselected: {
    width: 100,
    background: "#7964a8"
  },
  dashpad: {
    marginTop: "10px",
    display: '-webkit-box'
  },
  lth:{
    padding: "8px"
  },
  ltitle: {
    "marginLeft": "30px",
    width: 150,
    display:"flex",
    "overflow-y": "scroll",
    borderRight: "1px solid darkgrey"
  },
  rtitle:{
    "marginLeft": "10px",
  },
  rtable:{
    "marginLeft": "10px",
    width: (window.innerWidth -330)/5,
    height: window.innerHeight - 50,
  },
  rrow: {
    height: (window.innerHeight - 80)/4,
  },
  rth:{
    padding: "5px",
    textAlign: "center",
  },
  righttableimg: {
    width: (window.innerWidth -330)/5,
  }
});

const Dashboard = ({ }) => {
  const classes = useStyles();
  const [selected, setselected] = useState(0)
  const [removelist, setremovelist] = useState([])
  // const [update, setupdate] = useState(0)
  return (
    <div>
    <TableContainer component={Paper} className={classes.dashpad}>
      <div className={classes.ltitle}> Query visualizations </div>
      <div className={classes.rtitle}> Returned visualizations of different approaches</div>
    </TableContainer>
    <TableContainer component={Paper} className={classes.dashpad}>
      <Table aria-label="simple table" className={classes.table}>
        <TableBody className={classes.lefttableimg}>
          {query.filter((row,index) => removelist.indexOf(index)<0).map((row,index) => (
            <TableRow key={row[0]} className={selected==index?classes.lefttableimgselected:classes.lefttableimg} onClick={()=>setselected(index)}>
              <TableCell component="th" scope="row" className={classes.lth}>
                <img src={"/user_study_hog/"+row[1]} className={classes.lefttableimg} 
                  onError={() => setremovelist([...new Set(removelist.concat([row[0]]))])}></img>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      
      <Table aria-label="simple table" className={classes.rtable}>
        <TableBody className={classes.righttableimg}>
          {queryfigs[selected].map((row,index) => (
            <TableRow key={index} className={classes.rrow}>
              <TableCell key={-1} className={classes.textCenter}>{groupname[index] }</TableCell>
              {row.reverse().map((pic, i) => {
                return (<TableCell key={i} component="th" scope="row" className={classes.rth}>
                  <img src={"/user_study_hog/"+pic[0]+"/"+pic[1]} className={classes.righttableimg}></img>
                  {/* <span>value: {pic[1].split("_")[2].replace(".png","")}</span> */}
                </TableCell>)
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </div>
  )
}

export default Dashboard
